import React from "react";
import "./about.css"
const About = ({ t }) => {
    return (
        <>
            <div className="about">
                <div className="container">
                    <div className="about-flex">
                        <div className="about-sec1">
                            <h5 className="about-sec1-1">
                                {t("maintext4")}
                            </h5>
                        </div>
                        <div className="about-sec2">
                            <div className="about-sec2-1">
                                <h3 className="about-sec2-1-zagolovka">
                                    {t("Ocompany")}
                                </h3>
                                <div className="about-sec2-1-text">
                                    <h2>{t("Ocompany1")}</h2>
                                    <h2>{t("Ocompany2")}</h2>
                                    <h2>{t("Ocompany3")}</h2>
                                </div>
                                <div className="about-sec2-1-result">
                                    <span>
                                        <h1>+35.000</h1>
                                        <h5>{t("result1")}</h5>
                                    </span>
                                    <span>
                                        <h1>19</h1>
                                        <h5>{t("result2")}</h5>
                                    </span>
                                    <span>
                                        <h1>+20</h1>
                                        <h5>{t("result3")}</h5>
                                    </span>
                                    <span>
                                        <h1>24</h1>
                                        <h5>{t("result4")}</h5>
                                    </span>
                                </div>
                            </div>
                            <div className="about-sec2-2">
                                <img src="https://lh3.googleusercontent.com/fife/ALs6j_H40ei-f7u9x_4RtW1fjL_hYk6jO3e8jsDzne0w6cDcSdVAOdTHdchD0LXmhUkW5y6UV08MmFOQQv2ZuKU7G6L2bE8Fy_P1e-7W1v_YaMwLbvQs3sAoOoOufnCei1FF7NbJBv9PO7ryuEvvros07hk-_2EkhLG7Rkcwbm6stFIY-fn1Lmg0D-6H850RKnrU0VWgqtmfsMrQtxrD1IHaLz_ox0TH7HP44m6NHDCx_KEBJ_PuW1qGS190p99b_nRn12xh5L61P4yubK7wOJ7GlDYr8ycpiSBtxXAPQZ984f9KeixKmSFupDUD6qagxqxZi6szPv9mHmCBMTh7NxG1nY-Nws75tdMj5s5h4oDSMzrT2qHSZYvLxOXYo-c5Ljy8j0QIZ_pvdq1Ln9uw7v1TsS1JzDFCXjTUOTGWYq1b-qiLohOQFWE_GXBnNgBQ7SF_fKEM5WN4YbZNZOkDHsP2FBfqfuxAy03pFAcw8siC78JsiD7fvFTmN5giIh5cI-uX2LNUF81xAc6Hqvv1CbNlM94e0GvbCXGxKZg7YFt1VLaD-TLHgEqioMZpAemfaUWJFklTLNRMrSNH_L_sOUCVcjzbM3lungDHp1wSeFW8eUhe8Pt0kBSjJ7jX7oPrMOyg8K1MbWyI2v7C9U5FYn2mTCgUE_h9Fb-vN8wO9xXygkJ9kxqKCfy_9SixWP3kBFZ2nLz0KJhHauK_qEvg-dWy9fwaQ5hvzmuVGZzGwh6qdaVxPefOYh5cPS03sEs9JckRwv0siEJ9mbGsdc--e7xiUg9pL66A_4xic41iRIl6OFPVy33mTCSqzmpau_GomOMKhmSXGMh9RkDXSYWnP9x8y98jBUVlP9YXMhu7eaBW5gpdYiBsFh-_ivqjvVXp3JKd7EnHYHs9uEi1apr6Aw47p2_L7L8ZHmjxiIWbgEg-Rp3314rzvYpJoS1CGYNE4iypDOK0pcKRCi4DlAOV8a7AlDp1zEL7dKHD4XICaoW3QfQvW9xlsvRPSctowx-Q__Tt6b-tUXGBaNvFKq5R3ntPYFkYtZzXETR4xmqngFc-EDS_Bb5Tln1wo6MAovLGbXkIhJVYRV2eKL8wucdcINhpiwgKBjibd5bGVOAe84IQlWOfgyNY3ZOxM1jSATPOaSFEZ8qF_21lcxbvWrc1gp6WznQ9WNyDE124tuxJsv9nrdudnWYYT4CRI5ifghVBe583VMqEg8M6PXm7zottFIvDlheONy3q8J4ZkS9sHK7vtAKcfFIdEMgpyBS11XcifFCSHnvRYe9zSriLrzGyRfDyN4_xmH33vfu4rDkTDX_ug4gGofAxaTiA5Btxg1I-AENbHzfwb5asg5wSH9W1-357LcKTmrCdSuCKEJDe-AYtdkHVa_iwfXDfycUKR88h_YIzikphqzzkm2LwPMtbhzCR-7dAJzugd2T0ioylQTT20mAJyp9t9kkbsz0wRL_hoYBGNepxB_Gz2Ztd3TnccBjlavA6ju_sfGletePpoEwuIHHnYBsvlnfXHlv2KrRCawk_KsNtZII18PphgD_KM7fPrKEDaFh5FHdvi27PjUBIOC6ddSjLWd7TppewV4bhHDfsZgHcbpJqnhZFAbDB28gBCfbqQ36CAMPFRTlmppzDfyGNHOvVm1hnJ1z3atNXRmW0qsZDy7pAYDZeSvnunokeR72-5z8FcaFglehxqM2g46nPm-QnUF7-sU4ekYRXQA=w1428-h944" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default About;